import CustomTextField from "components/CustomTextField";
import {
  Col,
  Input,
  Row,
  Card,
  CardBody,
  CardTitle,
  CardHeader,
  Table,
  FormGroup,
  Label,
} from "reactstrap";
import { useParams, useLocation } from "react-router-dom";
import { Modal, Spinner, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import Select from "react-select";
import {
  useCreateResidentialDetailMutation,
  useUpdateResidentialDetailMutation,
  useGetFarmerResidenceByIdQuery,
} from "./farmerApiSlice";
import { useEffect, useState } from "react";
import {
  useGetStatesQuery,
  useGetDistrictByStateQuery,
  useGetBlockByDistrictQuery,
  useGetVillageByBlockQuery,
} from "services/locationApiSlice";
import swal from "sweetalert";
import "react-loading-skeleton/dist/skeleton.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import BusinessIcon from "@mui/icons-material/Business";
import FarmerNoResponse from "./FarmerNoResponse";
import CardSkeleton from "components/CardSkeleton";
import { Divider } from "@mui/material";

const FarmerDetailsResidential = () => {
  const { id } = useParams();
  const location = useLocation();

  const [ResidentailList, setResidentialList] = useState([]);
  const [disableButton, disableSubmitBtn] = useState(false);
  const [stateId, setStateId] = useState("");
  const [districtId, setDistrictId] = useState("");
  const [blockId, setBlockId] = useState("");
  const [villageId, setVillageId] = useState("");
  const { data: getStates } = useGetStatesQuery();
  const { data: dataDistrict } = useGetDistrictByStateQuery(stateId);
  const { data: dataBlock } = useGetBlockByDistrictQuery(districtId);
  const { data: dataVillage } = useGetVillageByBlockQuery(blockId);

  const { data: data, refetch, isLoading } = useGetFarmerResidenceByIdQuery(id);
  const [createResidense] = useCreateResidentialDetailMutation();
  const [updateResidense] = useUpdateResidentialDetailMutation();

  const [showAddModal, setshowAddModal] = useState(false);
  const [SubmitButtonApi, setSubmitButtonApi] = useState(false);
  const [updateId, setUpdateId] = useState("");
  const [showError, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [villageList, setVillageList] = useState([]);
  const [villageName, setVillageName] = useState("");
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [showLoader, setLoader] = useState(false);
  const [loadingStateOptions, setloadingStateOptions] = useState(true);
  const [loadingDistrictOptions, setloadingDistrictOptions] = useState(true);
  const [residentialPinState, setresidentialPinState] = useState("Pincode");
  const [PincodeValue, setPincode] = useState("");
  const [PincodeDataList, setPincodeDataList] = useState([]);
  const [pincodeError, setPinCodeError] = useState(false);

  const [Group, editGroup] = useState({
    address_type: "",
    address: "",
    state_name: "",
    state_code: "",
    district_name: "",
    district_code: "",
    block_name: "",
    block_code: "",
    village_name: "",
    village_code: "",
    // pincode:""
  });

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 40,
      minHeight: 40,
    }),
  };
  useEffect(() => {
    const userFromApi = data?.data ? data?.data : ResidentailList;
    if (userFromApi !== undefined) {
      setResidentialList(userFromApi);
    }
    if (getStates != undefined) {
      setStateList(getStates?.data?.results);
      setloadingStateOptions(false);
    }
  }, [data, getStates]);
  const handleStateOptions = () => {
    let responseAgentArray = [];
    stateList.map((state) => {
      responseAgentArray.push({
        value: state.state_code,
        label: state.state_name,
        ConditionName: "state",
      });
    });
    return responseAgentArray;
  };
  const handleDistrictOptions = () => {
    let responseAgentArray = [];
    districtList.map((district) => {
      responseAgentArray.push({
        value: district.district_code,
        label: district.district_name,
        ConditionName: "district",
      });
    });
    return responseAgentArray;
  };
  const handleBlockOptions = () => {
    let responseAgentArray = [];
    blockList.map((block) => {
      responseAgentArray.push({
        value: block.block_code,
        label: block.block_name,
        ConditionName: "block",
      });
    });
    return responseAgentArray;
  };
  const handleVillageOptions = () => {
    let responseAgentArray = [];
    villageList.map((block) => {
      responseAgentArray.push({
        value: block.village_code,
        label: block.village_name,
        ConditionName: "village",
      });
    });
    return responseAgentArray;
  };
  const onLocationChange = (event) => {
    if (event.ConditionName == "state") {
      setBlockId("");
      setDistrictName("");
      setDistrictId("");
      setBlockName("");
      setBlockList([]);
      setStateId(event.value);
      setStateName(event.label);
    }
    if (event.ConditionName == "district") {
      setDistrictId(event.value);
      setDistrictName(event.label);
      setBlockId("");
      setBlockName("");
    }
    if (event.ConditionName == "block") {
      setBlockId(event.value);
      setBlockName(event.label);
      setVillageId("");
      setVillageList([]);
    }
    if (event.ConditionName == "village") {
      setVillageId(event.value);
      setVillageName(event.label);
    }
  };
  useEffect(() => {
    if (dataDistrict != undefined) {
      setDistrictList(dataDistrict?.data?.results);
      setloadingDistrictOptions(false);
    }
  }, [dataDistrict]);
  useEffect(() => {
    if (dataBlock != undefined) {
      setBlockList(dataBlock?.data?.results);
    }
  }, [dataBlock]);
  useEffect(() => {
    if (dataVillage) {
      setVillageList(dataVillage?.data?.results);
    }
  }, [dataVillage]);
  const AddModal = (updateButtonTag, list) => {
    if (updateButtonTag) {
      setSubmitButtonApi(true);
      setUpdateId(list.id);
      setStateId(list.state_code);
      setDistrictId(list.district_code);
      setBlockId(list.block_code);
      setVillageId(list.village_code);
      setVillageName(list.village_name);
      setStateName(list.state_name);
      setDistrictName(list.district_name);
      setBlockName(list.block_name);
      setPincode(list.pincode);
      setPincodeDataList([]);
    }

    let currentList = {
      address_type: list.address_type,
      address: list.address,
      state_name: list.state_name,
      state_code: list.state_code,
      district_name: list.district_name,
      district_code: list.district_code,
      block_name: list.block_name,
      block_code: list.block_code,
      village_name: list.village_name,
      village_code: list.village_code,
      // pincode:list.pincode
    };
    // console.log("first check",currentList)
    editGroup(currentList);
    setshowAddModal(true);
    disableSubmitBtn(false);
  };
  const handleClose = () => {
    setshowAddModal(false);
    setError(false);
    setSubmitButtonApi(false);
    setUpdateId("");
    setStateId("");
    setDistrictId("");
    setBlockId("");
    setVillageId("");
    setStateName("");
    setDistrictName("");
    setBlockName("");
    setVillageName("");
    editGroup({
      home: "",
      address: "",
      state_name: "",
      state_code: "",
      district_name: "",
      district_code: "",
      block_name: "",
      block_code: "",
      village_name: "",
      village_code: "",
      // pincode:""
    });
    setresidentialPinState("Pincode");
    setPincode("");
    setPinCodeError(false);
    setPincodeDataList([]);
  };
  //  console.log("ResidentailList",ResidentailList)
  const onInputChange = (event) => {
    editGroup({
      ...Group,
      [event.target.name]: event.target.value,
    });
  };

  const ReloadApplication = () => {
    setLoader(true);
    setTimeout(() => {
      refetch();
      setLoader(false);
    }, 1500);
  };
  const handleResidentialChange = (e) => {
    setresidentialPinState(e.target.value);
  };
  const handlePinCodeChange = (e) => {
    const newPinCode = e.target.value;
    if (newPinCode.length <= 6) {
      setPincode(newPinCode);
    }
  };
  useEffect(() => {
    const apiUrl = `https://api.postalpincode.in/pincode/${PincodeValue}`;

    fetch(apiUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data[0].Status === "Success") {
          setPincodeDataList(data[0].PostOffice[0]);
          setPinCodeError(false);
        }
        if (data[0].Status === "Error") {
          setPinCodeError(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [PincodeValue]);

  const SendPinCodePayload = (e) => {
    e.preventDefault();
    setLoading(true);
    disableSubmitBtn(true);

    let payload = "";
    if (residentialPinState === "Pincode") {
      if (PincodeValue.length < 6 || pincodeError) {
        setPinCodeError(true);
        return;
      }
      payload = {
        state_name: PincodeDataList.State,
        district_name: PincodeDataList.District,
        block_name: PincodeDataList.Block,
        pincode: PincodeValue,
        address_type: Group.address_type,
        house_no: Group.house_no,
        street: Group.street,
        address: Group.address,
        address_name: Group.address_name,
      };
    } else {
      payload = {
        ...Group,
        state_name: stateName,
        state_code: stateId,
        district_name: districtName,
        district_code: districtId,
        block_code: blockId,
        block_name: blockName,
        village_code: villageId,
        village_name: villageName,
        address_type: Group.address_type,
        house_no: Group.house_no,
        street: Group.street,
        address: Group.address,
        address_name: Group.address_name,
      };
    }
    if (!SubmitButtonApi) {
      createResidense({ id: id, payload: payload })
        .unwrap()
        .then((data) => {
          swal("Detail Created Successfully", {
            buttons: false,
            icon: "success",
            title: "Successfully Created Detail",
            timer: 1500,
          });
          disableSubmitBtn(false);
          setLoading(false);
          setshowAddModal(false);
          setPincodeDataList([]);
          setPincode("");
          editGroup({
            home: "",
            address: "",
            state_name: "",
            state_code: "",
            district_name: "",
            district_code: "",
            block_name: "",
            block_code: "",
            village_name: "",
            village_code: "",
          });
          setresidentialPinState("");
          refetch();
        })
        .catch((error) => {
          toast.error("Error while Creating Detail");
          disableSubmitBtn(false);
          setLoading(false);
          return;
        });
    } else {
      updateResidense({ id: updateId, payload: payload })
        .unwrap()
        .then((data) => {
          swal("Detail Updated Successfully", {
            buttons: false,
            icon: "success",
            title: "Successfully Updated Detail",
            timer: 1500,
          });
          setshowAddModal(false);
          disableSubmitBtn(false);
          setLoading(false);
          refetch();
        })
        .catch((error) => {
          toast.error("Error while Updating Details");
          disableSubmitBtn(false);
          setLoading(false);
          return;
        });
    }
  };

  return (
    <Card className="globalboxshadow">
      <div
        className="d-flex justify-content-between  align-items-center "
        style={{ borderRadius: "5px", backgroundColor: "#f1f1f1" }}
      >
        <div className="heading-title mt-lg-0 mt-2 py-3">
          <h5
            className="mx-4"
            style={{
              fontSize: "18px",
              color: "black",
            }}
          >
            <i
              className="mdi mdi-account-hard-hat me-2"
              style={{ fontSize: "1.5rem" }}
            ></i>
            Residential Details
          </h5>
        </div>
        <div
          className="d-flex justify-content-end align-items-center flex-wrap"
          style={{ gap: "6px" }}
        >
          <Button
            id="AddDetails99"
            type=""
            className="buttonOrangeDefaultColor"
            onClick={() => AddModal(false, Group)}
            size="sm"
          >
            Add <i className="mdi mdi-account-plus custom-btn-fs fs-6"></i>
          </Button>
          <Button
            className="bg-transparent text-black fs-6 reloadButton me-2"
            size="sm"
            onClick={ReloadApplication}
          >
            Reload <FontAwesomeIcon icon={faRotateLeft} />
          </Button>
        </div>
      </div>

      {isLoading ? (
        <div className="mt-4">
          <CardSkeleton />
        </div>
      ) : ResidentailList.length === 0 ? (
        <FarmerNoResponse />
      ) : (
        <>
          <div className="p-1 p-lg-3 d-lg-none d-md-block d-block">
            <Row className="">
              {ResidentailList.map((item, index) => {
                return (
                  <Col lg="4" className="" key={index}>
                    <Card
                      style={{
                        borderRadius: "8px",
                        padding: "16px",
                        backgroundColor: "#fff",
                        transition: "transform 0.3s ease, box-shadow 0.3s ease",
                        cursor: "pointer",
                      }}
                      className="hover-shadow"
                    >
                      <CardTitle className="d-flex align-items-center justify-content-between mb-3">
                        <div className="d-flex align-items-center">
                          <BusinessIcon
                            className="f400"
                            style={{ fontSize: "18px", color: "#FF8C00" }}
                          />
                          <span
                            className="font-weight-bold"
                            style={{
                              fontSize: "15px",
                              color: "#333", // Darker color for better contrast
                              marginLeft: "8px",
                            }}
                          >
                            {item.address}
                          </span>
                        </div>
                        <FontAwesomeIcon
                          icon={faPenToSquare}
                          className="f400 cursor-pointer"
                          onClick={() => AddModal(true, item)}
                          style={{
                            fontSize: "16px",
                            color: "#FF8C00",
                            transition: "color 0.3s ease", // Smooth transition for hover effect
                          }}
                          onMouseEnter={(e) =>
                            (e.target.style.color = "#FF5722")
                          } // Change color on hover
                          onMouseLeave={(e) =>
                            (e.target.style.color = "#FF8C00")
                          } // Reset color on mouse leave
                        />
                      </CardTitle>
                      <hr
                        className="mt-0 mb-2"
                        style={{ borderColor: "#FF8C00" }}
                      />{" "}
                      {/* Orange separator for better contrast */}
                      <Table className="table mb-0" hover>
                        <tbody>
                          <tr>
                            <th> State: </th>
                            <td>{item?.state_name}</td>
                          </tr>
                          <tr>
                            <th> District: </th>
                            <td>{item?.district_name}</td>
                          </tr>
                          <tr>
                            <th> Block: </th>
                            <td>{item?.block_name}</td>
                          </tr>
                        </tbody>
                      </Table>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </div>
          {ResidentailList.map((item, index) => (
            <div className="">
              <Divider
                style={{ borderTop: "2px dotted orange", marginBottom: "5px" }}
              />
              <div className="row p-2 p-lg-3">
                <div className="col-6 col-lg-3 col-md-3 mb-3">
                  <CustomTextField
                    type="text"
                    name="state_name"
                    label="State"
                    value={item?.state_name || "N/A"}
                    disabled
                  />
                </div>
                <div className="col-6 col-lg-3 col-md-3 mb-3">
                  <CustomTextField
                    type="text"
                    name="district_name"
                    label="District"
                    value={item?.district_name || "N/A"}
                    disabled
                  />
                </div>
                <div className="col-6 col-lg-3 col-md-3 mb-3">
                  <CustomTextField
                    type="text"
                    name="block_name"
                    label="Block"
                    value={item?.block_name || "N/A"}
                    disabled
                  />
                </div>
                <div className="col-6 col-lg-3 col-md-3 mb-3">
                  <CustomTextField
                    type="text"
                    name="pincode"
                    value={item.pincode || "-"}
                    disabled
                  />
                </div>
                <div className="col-6 col-lg-1 col-md-1 mb-3">
                  <CustomTextField
                    type="text"
                    name="house_no"
                    value={item.house_no || "-"}
                    disabled
                  />
                </div>
                <div className="col-6 col-lg-2 col-md-2 mb-3">
                  <CustomTextField
                    type="text"
                    name="Street"
                    value={item.street_name || "-"}
                    disabled
                  />
                </div>{" "}
                <div className="col-6 col-lg-3 col-md-3 mb-3">
                  <CustomTextField
                    type="text"
                    name="land_mark"
                    value={item.nearest_landmark || "-"}
                    disabled
                  />
                </div>
                <div className="col-6 mb-3">
                  <CustomTextField
                    type="text"
                    name="address"
                    value={item.address || "-"}
                    disabled
                  />
                </div>
              </div>
              <div className="col-12 text-end p-2 mb-0 d-lg-block d-md-none d-none">
                <Button
                  id="editDetails"
                  type=""
                  className="buttonOrangeDefaultColor"
                  onClick={() => AddModal(true, item)}
                  size="sm"
                >
                  Edit&nbsp; <FontAwesomeIcon icon={faPenToSquare} />
                </Button>
              </div>
            </div>
          ))}
        </>
      )}

      <Modal show={showAddModal} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "" }} className="fw-bold">
            {SubmitButtonApi ? "Update" : "Add"} Residential Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Row>
            <Col lg="5" className="">
              <label>
                <b>{SubmitButtonApi ? "Update" : "Add"} Details Based on</b>
              </label>
              <FormGroup className="mt-2">
                <div className="d-flex flex-row">
                  <Label className="d-flex align-items-center">
                    <Input
                      type="radio"
                      name="home"
                      value="Pincode"
                      checked={residentialPinState === "Pincode"}
                      onChange={handleResidentialChange}
                    />
                    <span className="ms-2 mt-1">Pincode</span>
                  </Label>
                  <Label className="d-flex align-items-center mt-1 mx-5">
                    <Input
                      type="radio"
                      name="home"
                      value="StateLevel"
                      checked={residentialPinState === "StateLevel"}
                      onChange={handleResidentialChange}
                    />
                    <span className="ms-2 mt-1">
                      Based on State, District, Block
                    </span>
                  </Label>
                </div>
              </FormGroup>
            </Col>
          </Row>
          {residentialPinState === "Pincode" ? (
            <form onSubmit={(e) => SendPinCodePayload(e)}>
              <Row className="text-gray mt-2">
                <Col lg="3" className="mb-3">
                  <CustomTextField
                    type="select"
                    name="address_type"
                    required
                    onChange={onInputChange}
                    className="text-gray"
                    style={{ padding: "8px" }}
                    value={Group?.address_type}
                  >
                    <option value="">Select</option>
                    <option id="" value="Home">
                      Home
                    </option>
                    <option id="" value="Others">
                      Others
                    </option>
                  </CustomTextField>
                </Col>
                {Group.address_type === "Others" && (
                  <Col lg="3" className="mb-3">
                    <CustomTextField
                      type="text"
                      name="address_name"
                      value={Group.custom_address_type}
                      onChange={onInputChange}
                      placeholder="Enter Address Name"
                      className=""
                    />
                  </Col>
                )}

                <Col lg="3" className="mb-4">
                  <CustomTextField
                    type="text"
                    name="house_no"
                    value={Group.house_no}
                    onChange={onInputChange}
                    placeholder="House No"
                  />
                </Col>

                <Col lg="3" className="mb-4">
                  <CustomTextField
                    type="text"
                    name="street"
                    value={Group.street}
                    onChange={onInputChange}
                    placeholder="Street"
                  />
                </Col>
                <Col lg="3" className="mb-4">
                  <CustomTextField
                    type="text"
                    name="LandMark"
                    value={Group.nearest_landmark}
                    onChange={onInputChange}
                    placeholder="Landmark"
                  />
                </Col>

                {/* Pincode */}
                <Col lg="3" className="mb-4">
                  <CustomTextField
                    type="number"
                    name="pincode"
                    value={PincodeValue}
                    onChange={handlePinCodeChange}
                    maxLength="6"
                    placeholder="Pincode"
                    required
                  />
                  {PincodeValue.length > 6 || pincodeError ? (
                    <div className="text-danger mt-1">
                      Enter a valid pincode
                    </div>
                  ) : null}
                </Col>

                <Col lg="3" className="mb-4">
                  <CustomTextField
                    type="text"
                    name="State"
                    value={PincodeDataList.State || Group.state_name}
                    disabled
                    placeholder="State"
                  />
                </Col>
                <Col lg="3" className="mb-4">
                  <CustomTextField
                    type="text"
                    name="District"
                    value={PincodeDataList.District || Group.district_name}
                    disabled
                    placeholder="District"
                  />
                </Col>
                <Col lg="3" className="mb-4">
                  <CustomTextField
                    type="text"
                    name="Block"
                    value={PincodeDataList.Block || Group.block_name}
                    disabled
                    placeholder="Block"
                  />
                </Col>

                {/* Address */}
                <Col lg="8" className="mb-4">
                  <CustomTextField
                    type="text"
                    name="address"
                    value={Group.address}
                    onChange={onInputChange}
                    placeholder="Full Address"
                    required
                  />
                </Col>
              </Row>

              <div className="d-flex justify-content-end mt-3">
                <Button
                  className="submit-btn"
                  disabled={disableButton}
                  type="submit"
                >
                  Submit &nbsp;
                  {disableButton && <Spinner animation="border" size="sm" />}
                </Button>
              </div>

              {showError && (
                <div className="text-danger mt-2 text-center">
                  Please fill in all mandatory fields
                </div>
              )}
            </form>
          ) : residentialPinState === "StateLevel" ? (
            <form onSubmit={(e) => SendPinCodePayload(e)}>
              <Row className="text-gray mt-2">
                <Col lg="3" className="mb-3">
                  <CustomTextField
                    type="select"
                    name="address_type"
                    required
                    onChange={onInputChange}
                    className="text-gray"
                    style={{ padding: "8px" }}
                    value={Group?.address_type}
                  >
                    <option value="">Select</option>
                    <option id="" value="Home">
                      Home
                    </option>
                    <option id="" value="Others">
                      Others
                    </option>
                  </CustomTextField>
                </Col>
                {Group.address_type === "Others" && (
                  <Col lg="3" className="mb-3">
                    <CustomTextField
                      type="text"
                      name="address_name"
                      value={Group.custom_address_type}
                      onChange={onInputChange}
                      placeholder="Enter Address Name"
                      className=""
                    />
                  </Col>
                )}
                <Col lg="3" className="mb-4">
                  <CustomTextField
                    type="text"
                    name="house_no"
                    value={Group.house_no}
                    onChange={onInputChange}
                    placeholder="House No"
                  />
                </Col>
                <Col lg="3" className="mb-4">
                  <CustomTextField
                    type="text"
                    name="street"
                    value={Group.street}
                    onChange={onInputChange}
                    placeholder="Street"
                  />
                </Col>
                <Col lg="3" className="mb-4">
                  <CustomTextField
                    type="text"
                    name="LandMark"
                    value={Group.nearest_landmark}
                    onChange={onInputChange}
                    placeholder="Landmark"
                  />
                </Col>

                <Col lg="3" className="mb-4">
                  <label className="text-black"> State</label>
                  <Select
                    menuPlacement="auto"
                    options={handleStateOptions()}
                    placeholder={stateId === "" ? "Select State" : stateName}
                    value={stateId === "" ? "Select State" : stateName}
                    onChange={onLocationChange}
                    styles={customStyles}
                    isLoading={loadingStateOptions}
                    className="mt-2"
                  />
                </Col>
                <Col lg="3" className="mb-4">
                  <label className="text-black"> District</label>
                  <Select
                    menuPlacement="auto"
                    isLoading={loadingDistrictOptions}
                    options={handleDistrictOptions()}
                    placeholder={
                      districtName == "" ? "Select District" : districtName
                    }
                    value={
                      districtName === "" ? "Select District" : districtName
                    }
                    onChange={onLocationChange}
                    styles={customStyles}
                    className="mt-2"
                  />
                </Col>
                <Col lg="3" className="mb-4">
                  <label className="text-black"> Block</label>
                  <Select
                    menuPlacement="auto"
                    options={handleBlockOptions()}
                    placeholder={blockName == "" ? "Select Block" : blockName}
                    value={blockName === "" ? "Select Block" : blockName}
                    onChange={onLocationChange}
                    styles={customStyles}
                    className="mt-2"
                  />
                </Col>
                <Col lg="3" className="mb-4">
                  <label className="text-black"> Village</label>
                  <Select
                    menuPlacement="auto"
                    options={handleVillageOptions()}
                    placeholder={
                      villageName == "" ? "Select Village" : villageName
                    }
                    value={villageName === "" ? "Select Village" : villageName}
                    onChange={onLocationChange}
                    className=" mt-2"
                    styles={customStyles}
                    style={{ zIndex: "" }}
                  />
                </Col>

                <Col lg="6" className="mb-4">
                  <CustomTextField
                    type="text"
                    name="address"
                    value={Group.address}
                    onChange={onInputChange}
                  />
                </Col>
              </Row>
              <div className="d-flex justify-content-end mt-3">
                <Button
                  className="submit-btn"
                  disabled={disableButton}
                  type="submit"
                >
                  Submit &nbsp;
                  {disableButton && <Spinner animation="border" size="sm" />}
                </Button>
              </div>

              {showError ? (
                <div style={{ color: "red" }}>Please Fill Mandatory Felds</div>
              ) : (
                ""
              )}
            </form>
          ) : (
            ""
          )}
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </Card>
  );
};
export default FarmerDetailsResidential;
